import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { baseQuery } from '../../../utils';
import type {
  GetCompanyCodeTranslationQuery,
  GetCompanyCodeTranslationQueryVariables,
  CreateCompanyCodeTranslationInput,
  CreateCompanyCodeTranslationMutation,
} from '../../../graphql';
import { createCompanyCodeTranslation, getCompanyCodeTranslation } from '../../../graphql';
import { RTK_CACHE_LIFETIME } from '../../../config';
import type { TDSOptions } from '../types';

export const companyCodeTranslationApi = createApi({
  reducerPath: 'companyCodeTranslationApi',
  baseQuery: baseQuery,
  tagTypes: ['companyCodeTranslation'],
  endpoints: (builder) => ({
    getTDSOptions: builder.query<TDSOptions[], GetCompanyCodeTranslationQueryVariables>({
      query: (variables) => ({ body: getCompanyCodeTranslation, variables }),
      keepUnusedDataFor: RTK_CACHE_LIFETIME,
      providesTags: ['companyCodeTranslation'],
      transformResponse: (response: GetCompanyCodeTranslationQuery, m, variables) => {
        if (variables?.codetype === '1') {
          // tds
          return (
            response?.getCompanyCodeTranslation?.map((item) => {
              return { label: item?.codetext || '', value: item?.section || '', percentage: item?.codevalue || '' };
            }) || []
          );
        }
        return [];
      },
    }),
    createCompanyCodeTranslation: builder.mutation<CreateCompanyCodeTranslationMutation, CreateCompanyCodeTranslationInput>({
      query: (variables) => ({
        body: createCompanyCodeTranslation,
        variables,
      }),
      invalidatesTags: ['companyCodeTranslation'],
    }),
  }),
});
export const { useGetTDSOptionsQuery, useLazyGetTDSOptionsQuery, usePrefetch, useCreateCompanyCodeTranslationMutation } =
  companyCodeTranslationApi;
